import __request__ from "routing/request";
export function list() {
  return __request__("GET", "/system/serviceManager", null, {}, {
    "Accept": ["application/json"]
  });
}
